import { createContext } from 'react';

export const CourseContext = createContext(null);

